export default {
  en: {
    userList: 'User List',
    editUser: 'Edit User',
    username: 'Username',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    status: 'Status',
    update: 'Save Changes',
    cancel: 'Cancel',
    editUserSuccessTitle: 'Success',
    editUserSuccessMessage: 'Update User Success.'
  },
  th: {
    userList: 'ผู้ใช้',
    editUser: 'แก้ไขข้อมูลผู้ใช้',
    username: 'ชื่อผู้ใช้',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    email: 'อีเมล',
    status: 'สถานะ',
    update: 'บันทึก',
    cancel: 'ยกเลิก',
    editUserSuccessTitle: 'สำเร็จ',
    editUserSuccessMessage: 'แก้ไขข้อมูลผู้ใช้สำเร็จ'
  }
}
